import React, { useEffect, useState } from "react";
import CardEmpty from "Utils/Cards/CardEmpty";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import moment from "moment";
import { NotificationManager } from "react-notifications";
import { IngresosBodegaApi } from "../api/IngresosBodegaApi";
import Paginacion from "../../../../../../Utils/Components/Paginacion/Paginacion";
import LoadMask from "../../../../../../Utils/LoadMask/LoadMask";
import { FiltrosIngresos } from "./FiltrosIngresos";
import { IngresosTable } from "./IngresosTable";
import { useDebounce } from "../../../../../../Utils/Hooks/useDebounce";
import { getErrorFromResponse } from "../../../../../../../../utility/utils";
import { MetricasEstado } from "./MetricasEstado";

export const Listado = ({
    storageKey,
    estado,
    estadoMultiple = false,
    textoMetricas,
    recibidoBodegaMetricas,
}) => {
    const STORAGE_KEY = storageKey;
    const savedState = JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
    const filtros = savedState && savedState.filtros ? savedState.filtros : {};

    const fechaInicialDefault = filtros.fecha_inicial
        ? moment(filtros.fecha_inicial)
        : null;

    const fechaFinalDefault = filtros.fecha_final
        ? moment(filtros.fecha_final)
        : null;

    const estadoDefault = filtros.estado || null;

    const { control, watch } = useForm({
        defaultValues: {
            fecha_inicial: fechaInicialDefault,
            fecha_final: fechaFinalDefault,
            estado: estadoDefault,
        },
    });

    const [paletizaciones, setPaletizaciones] = useState([]);
    const [paginaSeleccionada, setPaginaSeleccionada] = useState(
        savedState.pagina || 1,
    );
    const [cantidadResultados, setCantidadResultados] = useState(0);

    const fecha_inicial = watch("fecha_inicial");
    const fecha_final = watch("fecha_final");
    const estadoSeleccionado = watch("estado");

    const { getPaletizaciones, cargando } = IngresosBodegaApi();

    const [refreshMetricasKey, setRefreshMetricasKey] = useState(0);

    // filtros compartidos entre el listado y las métricas
    const GetParamsFiltros = () => {
        const params = {
            estado: estadoSeleccionado ? estadoSeleccionado.value : estado,
        };

        if (fecha_inicial) {
            params.fecha_inicial = moment(fecha_inicial).format(
                "YYYY-MM-DD HH:mm:ss",
            );
        }

        if (fecha_final) {
            params.fecha_final = moment(fecha_final).format(
                "YYYY-MM-DD HH:mm:ss",
            );
        }

        return params;
    };

    const GetProducciones = async () => {
        try {
            const params = {
                ...GetParamsFiltros(),
                page: paginaSeleccionada,
            };

            const response = await getPaletizaciones(params);
            setPaletizaciones(response.results);
            setCantidadResultados(response.count);
        } catch (error) {
            // Si el error es por una página inválida, volvemos a la página anterior
            if (
                error &&
                error.detail === "Invalid page." &&
                paginaSeleccionada > 1
            ) {
                setPaginaSeleccionada((prev) => prev - 1);
                return;
            }

            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener las paletizaciones",
            );
            NotificationManager.error(errorMsg, "Error", 3000);

            setPaletizaciones([]);
            setCantidadResultados(0);
        }
    };

    useEffect(() => {
        GetProducciones();
    }, [paginaSeleccionada]);

    useEffect(() => {
        GetProducciones();
        setRefreshMetricasKey((prev) => prev + 1);
    }, [fecha_inicial, fecha_final, estadoSeleccionado]);

    useEffect(() => {
        const stateToSave = {
            filtros: {
                fecha_inicial,
                fecha_final,
                estado: estadoSeleccionado,
            },
            pagina: paginaSeleccionada,
        };

        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(stateToSave));
    }, [fecha_inicial, fecha_final, estadoSeleccionado, paginaSeleccionada]);

    return (
        <div className="ingresos-bodega__tab-wrapper">
            <LoadMask loading={cargando} blur>
                <CardEmpty noShadow>
                    <MetricasEstado
                        filtros={GetParamsFiltros()}
                        textoMetricas={textoMetricas}
                        refreshMetricasKey={refreshMetricasKey}
                        recibidoBodegaMetricas={recibidoBodegaMetricas}
                    />

                    <div className="ingresos-bodega__table-header">
                        <FiltrosIngresos
                            control={control}
                            onRefresh={() => {
                                GetProducciones();
                                setRefreshMetricasKey((prev) => prev + 1);
                            }}
                            resetPage={() => setPaginaSeleccionada(1)}
                            estadoMultiple={estadoMultiple}
                        />
                    </div>

                    <IngresosTable
                        paletizaciones={paletizaciones}
                        estado={estado}
                        estadoMultiple={estadoMultiple}
                    />
                    <Paginacion
                        cantidadResultados={cantidadResultados}
                        paginaSeleccionada={paginaSeleccionada}
                        setPaginaSeleccionada={setPaginaSeleccionada}
                    />
                </CardEmpty>
            </LoadMask>
        </div>
    );
};
